import { useSelector } from "@jti/store/reduxHooks";

type UseSubscription = {
  isSubscription: boolean;
};

export const useSubscription = (): UseSubscription => {
  const { isSubscription } = useSelector((state) => state.cart);
  const isSubscriptionOrder = useSelector(
    (state) => (state.order.orderDetails.data?.items || []).some((item) => item.subscription === 1) || false
  );

  return {
    isSubscription: isSubscription || isSubscriptionOrder,
  };
};
